<template>
  <div class="container-fluid cover">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 intro-logo">
          <img alt="denisecko" src="@/assets/DedeLogo.svg" />
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-10 col-md-6">
          <profile
            :title="profile.title"
            :quote="profile.quote.value"
            :quoteAuthor="profile.quote.author"
          ></profile>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Profile from "./profile.vue";
export default {
  props: {
    profile: Object
  },
  components: {
    Profile
  }
};
</script>

<style>
</style>
